import React from 'react';
import PropTypes from 'prop-types';
import { isNil } from 'ramda';
import { useTranslation } from 'react-i18next';

import TransactionPresenter, {
  REFUND_STATUSES,
  STATES,
} from '../../../../../../../presenters/TransactionPresenter';
import CashbackPresenter from '../../../../../../../presenters/CashbackPresenter';
import StorePresenter from '../../../../../../../presenters/StorePresenter';
import Select from '../../../../../../../components/Select';
import Row from '../../../../../../../components/Row';
import Column from '../../../../../../../components/Column';
import Label from '../../../../../../../components/Label';

const EditTransactionForm = (props) => {
  const { transaction, values, onChange, errors, cashback, stores } = props;
  const { t } = useTranslation();

  const stateOptions = STATES.map((state) => {
    return {
      label: TransactionPresenter.stateReadable({ state }),
      value: state,
    };
  });

  const refundStatusOptions = Object.values(REFUND_STATUSES).map((status) => {
    return {
      label: TransactionPresenter.refundStatusReadable({
        refundStatus: status,
      }),
      value: status,
    };
  });

  const storesOptions = stores.map((store) => {
    return {
      value: StorePresenter.id(store),
      label: StorePresenter.name(store),
    };
  });

  const defaultStoreOption = { value: '', label: '--select store--' };

  const canChangeStore = isNil(cashback);

  return (
    <div>
      <Row>
        <Column>
          <Label name="state" title="State" errors={errors} />
          <Select
            id="state"
            onChange={onChange}
            options={stateOptions}
            value={values.state}
          />
        </Column>
      </Row>
      {TransactionPresenter.isRefund(transaction) && (
        <Row>
          <Column>
            <Label name="refundStatus" title="Refund Status" errors={errors} />
            <Select
              id="refundStatus"
              onChange={onChange}
              options={refundStatusOptions}
              value={values.refundStatus}
            />
          </Column>
        </Row>
      )}
      <Row>
        <Column>
          <Label name="storeId" title="Store" errors={errors} />
          {!canChangeStore && (
            <span>{t('transaction.dialogs.warnings.removeCashback')}</span>
          )}
          <Select
            id="storeId"
            onChange={onChange}
            value={values.storeId}
            options={storesOptions}
            defaultOption={defaultStoreOption}
            disabled={!canChangeStore}
          />
        </Column>
      </Row>
    </div>
  );
};

EditTransactionForm.propTypes = {
  transaction: TransactionPresenter.shape(),
  cashback: CashbackPresenter.shape(),
  stores: PropTypes.arrayOf(StorePresenter.shape()),
  values: PropTypes.shape({}).isRequired,
  errors: PropTypes.shape({}),
  onChange: PropTypes.func.isRequired,
};

EditTransactionForm.defaultProps = {
  cashback: null,
  stores: [],
  errors: {},
};

export default EditTransactionForm;
